/*
THIS COMPONENT INCLUDING IN ALL ADMIN PAGES
 ---------------------------------------------*/
class ChangeArticleModeration {

    constructor() {
        this.moderationActiveSelector = '#is_moderation_active';
    }

    getData(form) {
        return $(form).serialize();
    }

    changeArticleCommentModeration() {
        let self = this;
        let data = self.getData(this.moderationActiveSelector);

        $.ajax({
            url: '/articles_comment_moderate',
            type: 'POST',
            data: data,
            success: function (response) {

                console.log('winner');

                // self.showSuccessMessage(response.data.message);
                // if (response.data.status_success) {
                //     window.location.reload();
                // }
            }
        });
    }

    showSuccessMessage(message) {
        alert(message);
    }

    init() {
        this.listenChangeModeration();
    }

    listenChangeModeration() {
        $(document).on('click', this.moderationActiveSelector, (event) => {
            event.stopPropagation();
            this.changeArticleCommentModeration();
        });
    }
}

module.exports = ChangeArticleModeration;